// Cookie consent state utility.
// - Stores the user's decision in localStorage with a timestamp (RGPD proof of consent).
// - Emits a "y5:consent-changed" DOM event so listeners can (re)load scripts.
// - Loads non-essential scripts (analytics, marketing) only after explicit opt-in.

const KEY = "y5_consent_v1";

export const DEFAULT = { necessary: true, analytics: false, marketing: false, date: null, version: 1 };

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT, ...parsed, necessary: true };
  } catch {
    return null;
  }
}

export function saveConsent(partial) {
  const next = { ...DEFAULT, ...(readConsent() || {}), ...partial, necessary: true, date: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("y5:consent-changed", { detail: next }));
  return next;
}

export function clearConsent() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent("y5:consent-changed", { detail: null }));
}

export function openConsentModal() {
  // Broadcast an "open" event; CookieConsent component listens to this and re-opens the banner.
  window.dispatchEvent(new CustomEvent("y5:consent-open"));
}

// --- Script loaders (only fired when the matching category is accepted) ---

let posthogLoaded = false;
function loadPostHog() {
  if (posthogLoaded || typeof window === "undefined") return;
  posthogLoaded = true;
  // Same PostHog loader as before but only runs after opt-in.
  (function (t, e) {
    var o, n, p, r;
    if (e.__SV) return;
    window.posthog = e; e._i = [];
    e.init = function (i, s, a) {
      function g(t, e) { var o = e.split("."); 2 == o.length && ((t = t[o[0]]), (e = o[1])), (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }); }
      p = t.createElement("script"); p.type = "text/javascript"; p.crossOrigin = "anonymous"; p.async = !0;
      p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js";
      r = t.getElementsByTagName("script")[0]; r.parentNode.insertBefore(p, r);
      var u = e; void 0 !== a ? (u = e[a] = []) : (a = "posthog"); u.people = u.people || [];
      u.toString = function (t) { var e = "posthog"; return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e; };
      u.people.toString = function () { return u.toString(1) + ".people (stub)"; };
      o = "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(" ");
      for (n = 0; n < o.length; n++) g(u, o[n]);
      e._i.push([i, s, a]);
    };
    e.__SV = 1;
  })(document, window.posthog || []);
  window.posthog.init("phc_DbsPb39SRc8z3EiQ6Dhj6ikv4H4rTKcht9d4sZSesceP", {
    api_host: "https://ap.emergent.sh",
    person_profiles: "identified_only",
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
  });
}

function optOutPostHog() {
  if (typeof window === "undefined") return;
  try { window.posthog && window.posthog.opt_out_capturing && window.posthog.opt_out_capturing(); } catch { /* noop */ }
}

export function applyConsent(consent) {
  if (!consent) return;
  if (consent.analytics) {
    loadPostHog();
    try { window.posthog && window.posthog.opt_in_capturing && window.posthog.opt_in_capturing(); } catch { /* noop */ }
  } else {
    optOutPostHog();
  }
  // Marketing category: no scripts loaded (Meta/TikTok/Reddit/Criteo removed on request).
}
